import React from "react";
import { observable } from "mobx";
import { observer, inject } from "mobx-react";

import { Grid, Dialog, DialogContent } from "@material-ui/core";
import { IManagementStore } from "Stores/Management/types";
import { IValuesStore } from "Stores/Values/types";
import AddIcon from "@material-ui/icons/Add";
import { Values } from "@src/Tools/Values";
import { IAuthApplication } from "@src/Interfaces/Entity/OAuthApplication";
import AuthApplicationForm from "../AuthApplicationForm/AuthApplicationForm";
import { IAuthStore } from "@src/Stores/Auth/types";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  management?: IManagementStore;
  values?: IValuesStore;
  auth?: IAuthStore;
}

@inject("auth", "management", "values")
@observer
class AddAuthApplication extends React.Component<IProps> {
  @observable opened: boolean = false;

  handleOpen = () => {
    this.opened = true;
  };

  handleClose = () => {
    this.opened = false;
  };

  handleCreate = async (values: IAuthApplication) => {
    try {
      values.id = "00000000-0000-0000-0000-000000000000";
      await this.props.management.saveOAuthApplication(values, true);
      this.handleClose();
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const initialValues: IAuthApplication = {
      id: "",
      time: new Date(),
      name: "",
      state: 0,
      clientId: "",
      clientSecret: "",
      redirectUrls: [],
      locationId: this.props.auth.user.location.id,
      protocolType: 0
    };
    return (
      <Grid item>
        <RoundButton
          icon={<AddIcon/>}
          tooltipTitle={Values.getLocalizationValue("add")}
          onClick={() => this.handleOpen()}
          color={"green"}
        />
        
        <Dialog open={this.opened} onClose={this.handleClose}>
          <DialogContent>
            <AuthApplicationForm
              title={Values.getLocalizationValue("add")}
              initialValues={initialValues}
              onSubmit={this.handleCreate}
              onClose={this.handleClose}
            />
          </DialogContent>
        </Dialog>
      </Grid>
    );
  }
}

export default AddAuthApplication;
